import React from 'react';
import './Home.css';

// Import required components and constants
import { Button } from '../../../components';
import { homeContent } from '../../../constants';

// Import icons
import { FaTaxi } from 'react-icons/fa';

// Import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles  
import 'swiper/css'; 
import 'swiper/css/pagination'; 
import 'swiper/css/navigation';



const Home = () => {

  return (
    <section className='home'>

      {/* Home Slider Container */}
      <div className='home-slider'>

        <Swiper
          // Install Swiper modules
          modules={[Navigation, Pagination, Autoplay]}
          loop={true} // Enables infinite looping
          autoplay={{ delay: 100000, disableOnInteraction: true }} // Auto-slide settings
          navigation // Enables navigation buttons
          pagination={{ clickable: true }} // Enables pagination dots
        >
          {
            homeContent.map((home) => {
              return (
                <SwiperSlide className='home-item' key={home.id}>

                  {/* Background image for each slide */}
                  <img src={home.image} alt="Home-Pic" />

                  {/* Content overlay */}
                  <div className="content">
                    <div className="text">

                      <div className='intro'>
                        <div className='icon'><FaTaxi /></div>
                        <h5>{home.subtitle}</h5>
                        <div className='icon'><FaTaxi /></div>
                      </div>

                      <h3>{home.headingPart1} <span>{home.spanText}</span> {home.headingPart2}</h3> {/* Main heading with highlighted text */}
                      <Button link={home.buttonLink} title={home.buttonText} /> {/* CTA Button */}

                    </div>
                  </div>

                </SwiperSlide>
              )
            })
          }
        </Swiper>
      </div>
    </section>
  )
}

export default Home;